import React from "react";
import { Button } from "./ui/button";
import { 
  MessageSquare,
  Phone, 
  Mail,
  MapPin,
  Star
} from "lucide-react";

const Footer = () => {
  return (
    <footer className="bg-gray-900 text-white">
      <div className="container mx-auto px-4 py-8 sm:py-12">
        {/* Main Footer Content */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 sm:gap-8 mb-6 sm:mb-8">
          {/* Company Info */}
          <div className="lg:col-span-2">
            <h3 className="text-xl sm:text-2xl font-bold text-amber-400 mb-3 sm:mb-4">Sddolphinflipper</h3>
            <p className="text-gray-300 mb-4 text-sm sm:text-base">
              Aaron Hands Real Estate Development - Transforming San Diego properties since 2014. 
              Specializing in creative renovations, innovative designs, and community-focused development.
            </p>
            <div className="flex flex-col sm:flex-row gap-2 sm:gap-4">
              <a 
                href="tel:+14242830606" 
                className="text-amber-400 hover:text-amber-300 transition-colors text-sm sm:text-base"
              >
                📞 +1 (424) 283-0606
              </a>
              <a 
                href="mailto:automaticartinc@gmail.com" 
                className="text-amber-400 hover:text-amber-300 transition-colors text-sm sm:text-base"
              >
                ✉️ automaticartinc@gmail.com
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-lg font-bold text-white mb-3 sm:mb-4">Quick Links</h4>
            <ul className="space-y-2 text-sm sm:text-base">
              <li><a href="#home" className="text-gray-300 hover:text-amber-400 transition-colors">Home</a></li>
              <li><a href="#gallery" className="text-gray-300 hover:text-amber-400 transition-colors">Portfolio</a></li>
              <li><a href="#about" className="text-gray-300 hover:text-amber-400 transition-colors">About</a></li>
              <li><a href="#contact" className="text-gray-300 hover:text-amber-400 transition-colors">Contact</a></li>
            </ul>
          </div>

          {/* Services */}
          <div>
            <h4 className="text-lg font-bold text-white mb-3 sm:mb-4">Services</h4>
            <ul className="space-y-2 text-sm sm:text-base">
              <li className="text-gray-300">Property Acquisition</li>
              <li className="text-gray-300">Complete Renovation</li>
              <li className="text-gray-300">Kitchen Remodeling</li>
              <li className="text-gray-300">Bathroom Renovation</li>
              <li className="text-gray-300">Project Management</li>
            </ul>
          </div>
        </div>

        {/* Social Media & Contact Actions */}
        <div className="border-t border-gray-700 pt-6 sm:pt-8">
          <div className="flex flex-col sm:flex-row justify-between items-center gap-4">
            {/* Social Media */}
            <div className="flex items-center space-x-4">
              <span className="text-gray-300 text-sm sm:text-base">Connect with us:</span>
              <div className="flex space-x-3">
                <Button
                  size="sm"
                  variant="outline"
                  className="border-gray-600 text-gray-300 hover:bg-green-600 hover:text-white hover:border-green-600 p-2"
                  onClick={() => {
                    const phoneNumber = "+14242830606";
                    const message = encodeURIComponent("Hi, I found your contact on your website. I'm interested in learning more about your property development services.");
                    window.open(`https://wa.me/${phoneNumber}?text=${message}`, '_blank');
                  }}
                >
                  <MessageSquare className="w-4 h-4" />
                </Button>
                <Button
                  size="sm"
                  variant="outline"
                  className="border-gray-600 text-gray-300 hover:bg-blue-600 hover:text-white hover:border-blue-600 p-2"
                  onClick={() => window.open('tel:+14242830606', '_self')}
                >
                  <Phone className="w-4 h-4" />
                </Button>
                <Button
                  size="sm"
                  variant="outline"
                  className="border-gray-600 text-gray-300 hover:bg-amber-600 hover:text-white hover:border-amber-600 p-2"
                  onClick={() => window.open('mailto:automaticartinc@gmail.com?subject=Property Development Inquiry', '_self')}
                >
                  <Mail className="w-4 h-4" />
                </Button>
              </div>
            </div>

            {/* Quick Contact */}
            <Button
              className="bg-amber-600 hover:bg-amber-700 text-white px-4 sm:px-6 py-2 text-sm sm:text-base"
              onClick={() => {
                const phoneNumber = "+14242830606";
                const message = encodeURIComponent("Hi Aaron, I'm interested in starting a property project. When would be a good time to discuss?");
                window.open(`https://wa.me/${phoneNumber}?text=${message}`, '_blank');
              }}
            >
              <MessageSquare className="w-4 h-4 mr-2" />
              Start Project Chat
            </Button>
          </div>
        </div>

        {/* Copyright */}
        <div className="border-t border-gray-700 mt-6 sm:mt-8 pt-4 sm:pt-6 text-center">
          <p className="text-gray-400 text-xs sm:text-sm">
            © 2025 Sddolphinflipper - Aaron Hands Real Estate Development. All rights reserved.
            <br className="sm:hidden" />
            <span className="hidden sm:inline"> | </span>
            Transforming San Diego properties since 2014.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
